import styled from 'styled-components'

export const LayoutContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: end;
  justify-content: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.md - 1}px) {
    width: calc(100vw - 64px);
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    justify-content: end;
    align-items: center;
    margin-bottom: 0;
  }
`

export const FileExportActions = styled.div`
  display: flex;
  gap: 4px;

  button,
  a {
    border: 0;
    padding: 0;

    > figure {
      color: #ffffff;
    }
  }
`

export const LayoutAutocompleteWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  width: 100%;

  > :last-child {
    width: 100%;

    > * > * {
      background: #fff;
    }

    * {
      color: #303032;
    }
  }
`
